import React, { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, Typography, Button } from '@material-ui/core';

const HotKanbanCard = ({ event }) => {
  const history = useHistory();
  const cardRef = useRef(null);

  const isHighlighted = Boolean(event.__highlighted);

  useEffect(() => {
    if (isHighlighted && cardRef.current) {
      cardRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, [isHighlighted]);

  const handleOpenSourceTicket = () => {
    if (event.sourceTicketUuid) {
      history.push(`/tickets/${event.sourceTicketUuid}`);
    }
  };

  return (
    <Card
      ref={cardRef}
      style={{
        marginBottom: 8,
        cursor: event.sourceTicketUuid ? 'pointer' : 'default',
        border: isHighlighted ? '2px solid #ff9800' : undefined,
        boxShadow: isHighlighted ? '0 0 12px rgba(255, 152, 0, 0.8)' : undefined
      }}
      onClick={handleOpenSourceTicket}
    >
      <CardContent>
        <Typography variant="subtitle1">
          {event.contactName || 'Sem Nome'}
        </Typography>

        <Typography variant="body2">
          {event.contactNumber || event.contact?.number || 'Telefone não informado'}
        </Typography>

        <Typography variant="body2" style={{ marginTop: 8 }}>
          Evento #{event.id}
        </Typography>

        <Typography variant="body2">
          Ticket Origem: {event.sourceTicketId}
        </Typography>

        <Typography variant="body2">
          Score: {event.leadScore}
        </Typography>

        <Typography variant="body2">
          Temperatura: {event.leadTemperature}
        </Typography>

        {event.sourceTicketUuid && (
          <Button
            size="small"
            variant="contained"
            style={{
              marginTop: 8,
              backgroundColor: '#0d6efd',
              color: '#fff',
              fontWeight: 'bold'
            }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleOpenSourceTicket();
            }}
          >
            Ver Ticket
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default HotKanbanCard;
